<template>
  <div class="content">
    <div class="container-fluid">
      <!-- https://getbootstrap.com/docs/4.0/components/navbar/ -->
      <nav class="navbar navbar-expand-lg">
        <span class="nowrap">Liste des comptes </span>
        <li class="nav-item nav-link">
          <form class="form-inline my-1 my-lg-2">
            <input v-model="filter" class="form-control mr-sm-2" type="search" placeholder="Chercher" aria-label="Chercher">
          </form>
        </li>
        <li class="nav-item nav-link">
          <router-link class="btn btn-secondary" :to="urlWithRedirect('/register')">Nouveau compte</router-link>
        </li>
      </nav>
      <nav class="navbar navbar-expand-lg">
          <li class="nav-item nav-link">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-2"
              ></b-pagination>
          </li> 
          <li class="nav-item nav-link d-flex align-items-center">
            <span class="nowrap">Elements par page :</span>
            <select v-model="perPage" class="form-control">
                <option>10</option>
                <option>20</option>
                <option>50</option>
              </select>
          </li>
        <li class="na-item nav-link">
          <span>{{ totalRows }} / {{ totalInitial }}</span>
        </li>
      </nav>
      
        <div>
        <b-table striped hover 
          responsive
          
          v-if="items.length>0"
          :items="items" 
          :fields="columns" 
          :filter="filter"
          :current-page="currentPage"
          :per-page="perPage"
          @filtered="onFiltered"
          filter-debounce="300"
          @head-clicked="onHeadClicked"
          :sort-compare="sortCompare"
          
          > 
          <!--data-state-save="true"
          data-state-save-id="companiesId"-->
          <!-- show-empty -->
          <!-- stacked="md" -->
          <!-- small -->

          <!-- A virtual column --> 
          <template #cell(_status)="row">
            <status-icon :status="row.item._status" />
          </template>
          <template #cell(company_isHost)="row">
            
            <i class="nc-icon nc-pin-3" style="font-size:20pt;" v-if="row.item.company.isHost" title="Entreprise Utilisatrice"/>
            <!-- <b-icon icon="pencil-square"></b-icon> -->
            <!-- <i class="nc-icon nc-settings-90" v-if="row.item.company.isHost" title="Entreprise Utilisatrice"/> -->
          </template>
          <template #cell(name)="row">
            <!-- https://bootstrap-vue.org/docs/icons#icons-1 -->
            <router-link v-if="row.item.company.isHost"  :to="urlWithRedirect('/ppe_eu/home/'+row.item.id)"> {{row.item.name}}</router-link>
            <router-link v-if="!row.item.company.isHost" :to="urlWithRedirect('/ppe_ee/home/'+row.item.id)">{{row.item.name}}</router-link>
          </template>
          <template #cell(company_name)="row">
            <router-link :to="urlWithRedirect('/admin/company/'+row.item.company.id)">{{row.item.company.name}}</router-link>
          </template>
          <template #cell(id)="row">
            <a href="#" @click="impersonate(row.item.id)"><b-icon icon="lock-fill"></b-icon> Role de</a>
          </template>
          <template #cell(groups)="row">
            <!-- https://bootstrap-vue.org/docs/icons#icons-1 -->
            {{groupsToText(row.item.groups)}}            
          </template>

          <template #cell(_created)="row">
            {{toDate(row.item._created)}}            
          </template>

          <template #cell(index)="row">
            {{getFullIndexInTable(row.index +1)}}            
          </template>

        </b-table>
        </div>

        <nav v-if="totalRows > 10" class="navbar navbar-expand-lg">
          <li class="nav-item nav-link">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-2"
              ></b-pagination>
          </li> 
          <li class="nav-item nav-link d-flex align-items-center">
            <span class="nowrap">Elements par page :</span>
            <select v-model="perPage" class="form-control">
                <option>10</option>
                <option>20</option>
                <option>50</option>
              </select>
          </li>
        <li class="na-item nav-link">
          <span>{{ totalRows }} / {{ totalInitial }}</span>
        </li>
      </nav>

    </div>
  </div>
</template>

<style>
.table > tbody > tr > td:last-child {
  width: auto;
}

.col-name {
  width: 20%;
}

.col-created {
  width: 10%;
}
.nowrap {
  white-space: nowrap;
}
</style>

<script>
import StatusIcon from '../../components/StatusIcon.vue'

const Business = require('ppe-business')

import common from '../common/pages.js'

export default {
  components: {
    StatusIcon,
  },

  data() {
    return { 
      items : [ ],
      columns: [
        'index',
          {key:'_status',       label:'Etat',    sortable: true, thClass:"col-status"}, 
          {key:'company_isHost',label:'EU',      sortable: true, thClass:"col-ishost"}, 
          {key:'name',          label:'Nom',     sortable: true, thClass:"col-name"}, 
          {key:'email',         label:'Email',   sortable: true, thClass:"col-email"},
          {key:'company_name',  label:'Société / Pôle', sortable: true, thClass:"col-company"},
          {key:'_created',      label:'Créé',    sortable: true, thClass:"col-created"},
          {key:'groups',        label:'Roles',   sortable:true,  thClass:"col-roles"}, 
          {key:'id',            label:'Action',                  thClass:"col-id"},
          ],
      filter: null,
      currentPage:1,
      totalRows:0,
      totalInitial:0,
      perPage:20,

    }
  },

  mounted() {
      this.$http.get('/admin/accounts')
        .then(response => {
          console.log("/admin/accounts", response.data)
          // Map the result to add the _rowVariant attribute to color the full line
          this.items = response.data.accounts.map( function (a)  { 
            // https://bootstrap-vue.org/docs/components/table#items-record-data
            return {...a, _rowVariant:Business.getStatusClass(a._status)} } )
          this.totalRows = this.items.length
          this.totalInitial = this.totalRows
          }
          )
        .catch( (err, res) => {
          // Clone the error to read the status property (otherwise it can only be read once !!!!)
          let error = JSON.parse( JSON.stringify(err) )
          //console.error("PPEHome.vue:res", err.response)
					
          //console.error("PPEHome.vue:mounted", JSON.stringify(error))
					swal("Erreur", JSON.stringify(err.response ? err.response.data : error.message), "error");
          //if(error.status === 401)
          //   this.$router.replace("/login?redirect="+error.config.url)
        })
    },



  methods: {
    ...common.methods,
    toDate(apiDate) { return Business.toDate(apiDate) },
    groupsToText(groups) {
      let txt = ""
      if(groups)
        for(let group of groups)
          txt += Business.getGroupLabel(group) + "; "

      return txt;
    },

    getFullIndexInTable(i) {
      return this.perPage * (this.currentPage-1) + i
    },

    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
    },

    onHeadClicked(key, field, event, isFooter) {
      console.log("onHeadClicked", key)
    },

    sortCompare(a, b, key) {
      if (key === 'company_name') {
        return a.company.name.localeCompare(b.company.name);
      }
      if (key === '_status') {
        return a._status.localeCompare(b._status);
      }
      if (key === 'company_isHost') {
        return `${a.company.isHost}`.localeCompare(`${b.company.isHost}`);
      }
      if (key === 'name') {
        return a.name.localeCompare(b.name);
      }
      if (key === 'email') {
        return a.email.localeCompare(b.email);
      }
      if (key === '_created') {
        return a._created.localeCompare(b._created);
      }
      if (key === 'groups') {
        return a.groups[0].localeCompare(b.groups[0]);
      }
      return 0;
    },

    async impersonate(userId) {
        let response={};
        try {
        response = await this.$http.get( "/admin/impersonate?id="+userId )
        console.log("impersonate:response.data", response.data)
        let token = response.data.token;
          if(this.$usermanager.impersonateUser(token, response.data.impersonatedByToken)) {
            if( this.$usermanager.isAdmin() && !this.$usermanager.isImpersonating() )
              this.$router.push("/admin")
            else if( this.$usermanager.isHost()) 
              this.$router.push("/ppe_eu")
            else  
              this.$router.push("/ppe_ee")
          }
        } catch(ex){
            swal("Impersonate", ex.message + ";" + JSON.stringify(ex.response.data.error))
        }
      },


  }
}
</script>